/*
 * gift-photo-upload.js — drives the "send your photo later" page.
 * Prefills order/email from the URL, uploads the photo to Cloudinary, then
 * pushes a Klaviyo client event so the team is notified which order the photo
 * belongs to. See sections/gift-photo-upload.liquid.
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function init() {
    var root = document.querySelector('.gpu');
    var form = document.getElementById('GiftPhotoForm');
    if (!root || !form) return;

    var orderInput = document.getElementById('GiftPhoto-order');
    var emailInput = document.getElementById('GiftPhoto-email');
    var fileInput = document.getElementById('GiftPhoto-file');
    var errorEl = document.getElementById('GiftPhoto-error');
    var successEl = document.getElementById('GiftPhoto-success');
    var submitBtn = form.querySelector('.gpu__submit');

    var statusEl = root.querySelector('[data-upload-status]');
    var thumbEl = root.querySelector('[data-upload-thumb]');
    var textEl = root.querySelector('[data-upload-text]');
    var progressEl = root.querySelector('[data-upload-progress]');
    var barEl = root.querySelector('[data-upload-bar]');

    // Prefill from the email link.
    var orderParam = param('order');
    var emailParam = param('email');
    if (orderParam && orderInput) orderInput.value = orderParam;
    if (emailParam && emailInput && !emailInput.value) emailInput.value = emailParam;

    var publicId = '';

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }
    function clearError() {
      if (errorEl) errorEl.style.display = 'none';
    }
    function setText(t) {
      if (textEl) textEl.textContent = t || '';
    }

    if (window.VerideCloudinaryUploader && fileInput) {
      window.VerideCloudinaryUploader.create({
        input: fileInput,
        cloudName: root.dataset.cloudName,
        uploadPreset: root.dataset.uploadPreset,
        folder: root.dataset.uploadFolder,
        maxMb: parseInt(root.dataset.maxMb, 10) || 10,
        getExtraFields: function () {
          // Stamp the order number onto the asset so it's findable in Cloudinary
          // (tag for filtering, context for the details panel).
          var raw = (orderInput && orderInput.value || '').trim();
          var slug = raw.replace(/[^a-z0-9]/gi, '');
          if (!slug) return {};
          return { tags: 'order-' + slug, context: 'order=' + raw };
        },
        onStart: function (previewUrl) {
          publicId = '';
          if (statusEl) statusEl.hidden = false;
          if (previewUrl && thumbEl) {
            thumbEl.src = previewUrl;
            thumbEl.hidden = false;
          }
          setText(root.dataset.strUploading);
          if (progressEl) progressEl.hidden = false;
          if (barEl) barEl.style.width = '0%';
        },
        onProgress: function (pct) {
          if (barEl) barEl.style.width = pct + '%';
        },
        onSuccess: function (id) {
          publicId = id;
          if (progressEl) progressEl.hidden = true;
          setText(root.dataset.strDone);
        },
        onError: function (code) {
          publicId = '';
          if (progressEl) progressEl.hidden = true;
          if (thumbEl) thumbEl.hidden = true;
          if (statusEl) statusEl.hidden = false;
          var msg = root.dataset.strError;
          if (code === 'size') msg = root.dataset.strToobig;
          else if (code === 'type') msg = root.dataset.strWrongtype;
          setText(msg);
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var order = (orderInput && orderInput.value || '').trim();
      var email = (emailInput && emailInput.value || '').trim();

      if (!order) {
        showError('Please add your order number.');
        return;
      }
      if (!EMAIL_RE.test(email)) {
        showError('Please enter the email from your order.');
        return;
      }
      if (!publicId) {
        showError('Please choose a photo and let it finish uploading.');
        return;
      }

      var company = root.dataset.klaviyoCompany;
      var metric = root.dataset.klaviyoMetric || 'Gift box photo submitted';
      if (submitBtn) submitBtn.disabled = true;

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: metric } } },
              properties: {
                order_number: order,
                cloudinary_id: publicId,
                cloudinary_folder: root.dataset.uploadFolder || ''
              },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.text().then(function (t) {
              throw new Error(t);
            });
          }
          form.style.display = 'none';
          if (successEl) successEl.style.display = 'block';
        })
        .catch(function (err) {
          console.error('[Klaviyo] gift photo submit failed:', err && err.message);
          showError('Something went wrong. Please try again.');
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
